import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { Baseproperties } from "src/app/views/utility/baseproperties";

@Injectable({ providedIn: 'root' })
export class LocationService {
  constructor(private httpClient: HttpClient, private route: Router) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common';

  postlocation(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/location/create`, payload);  // audit Add
  }
  modifylocation(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/location/updatelocation`, payload);  // audit update
  }
  getall_location(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/location/locationdata/`, payload);
  }
  getLocationDataView_byId(locationid: String, selectedorgid: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/location/findlocation/${locationid}/${selectedorgid}`);
  }
  getLocationtype(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/location/forlist/locationtype`);
  }
  // locationDataExcel(selectedorgid: String) {
  //   return this.httpClient.get(`${this.baseURL}/location/locationDataExcel/${selectedorgid}`, { responseType: 'blob' });
  // }

  locationDataExcel(payload) {
    return this.httpClient.post(`${this.baseURL}/location/locationdataexcel`, payload, { responseType: 'blob' });
  }

  excelUploadFormat() {
    return this.httpClient.get(`${this.baseURL}/location/bulkuploadTempExcel`, { responseType: 'blob' });
  }
  getlocationforlist(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/forlist/loc`);
  }
  getcontryforlist(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/forlist/getcontry`);
  }
  getregionforlist(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/forlist/region`);
  }
  gethubforlist(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/forlist/hub`);
  }
  getcityforlist(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/forlist/city`);
  }
  getstateforlist(id): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/forlist/state/${id}`);
  }
  getConfiguration(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.baseURL}/location/getconfiguration`);
  }
  getOrganisations(): Observable<any> {
    return this.httpClient.get<Observable<any>>(`${this.baseURL}/location/getorganisations`);
  }
  getConfigurationSuperAdmin(selectedorgid: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/location/getsuperadminconfiguration/${selectedorgid}`);
  }

} 